import React from 'react';

import DateSelectorMenu from './DateSelectorFilterMenu';
import ItemSelectorMenu from './ItemSelectorFilterMenu';
import TextSelectorFilterMenu from './TextSelectorFilterMenu';
const FilterSelectorMenu = ({
  addFilter,
  currentFilter,
  openCustomDateSelection,
  setOpenCustomDateSelection,
  showMenuItemSelectBox,
  showSelectedDisabled,
  virtualLoadWidth,
  virtualLoadHeight,
  allowDateRangeSelection,
}) => {
  switch (currentFilter?.type) {
    case 'date':
      return (
        <DateSelectorMenu
          addFilter={addFilter}
          currentFilter={currentFilter}
          openCustomDateSelection={openCustomDateSelection}
          setOpenCustomDateSelection={setOpenCustomDateSelection}
          showMenuItemSelectBox={showMenuItemSelectBox}
          showSelectedDisabled={showSelectedDisabled}
          virtualLoadWidth={virtualLoadWidth}
          virtualLoadHeight={virtualLoadHeight}
          allowDateRangeSelection={allowDateRangeSelection}
        />
      );
    case 'menu':
      return (
        <ItemSelectorMenu
          currentFilter={currentFilter}
          addFilter={addFilter}
          showMenuItemSelectBox={showMenuItemSelectBox}
          showSelectedDisabled={showSelectedDisabled}
          virtualLoadWidth={virtualLoadWidth}
          virtualLoadHeight={virtualLoadHeight}
        />
      );
    case 'text':
      return <TextSelectorFilterMenu currentFilter={currentFilter} addFilter={addFilter} />;
    default:
      return <></>;
  }
};

export default FilterSelectorMenu;
